/** Códigos de tipo_movimiento alineados con el backend de inventario */

export const TIPO_RECLASIFICACION_RESTA = 'reclasificacion_resta'
export const TIPO_RECLASIFICACION_SUMA = 'reclasificacion_suma'

/** Solo UI: el usuario elige este botón y el flujo envía resta+suma con categorías origen/destino */
export const TIPO_RECLASIFICACION_UI = '__ui_reclasificacion_categoria__'

/** Textos de interfaz por código de tipo (si el API trae otro texto, estos tienen prioridad) */
export const DESCRIPCION_TIPO_MOVIMIENTO: Record<string, string> = {
  registro_inicial: 'Registro inicial del inventario',
  traslado_salida: 'Traslado hacia otra finca',
  traslado_ingreso: 'Ingreso desde otra finca',
  traslado_hierro_salida: 'Traslado entre hierros: salida del hierro origen',
  traslado_hierro_ingreso: 'Traslado entre hierros: ingreso al hierro destino',
  robo: 'Pérdida por robo',
  nacimiento: 'Nacimiento de cría',
  compra: 'Compra de ganado',
  venta: 'Venta de ganado',
  venta_accidente: 'Venta por accidente',
  ingreso_transito: 'Ingreso en tránsito',
  reclasificacion_suma: 'Reclasificación interna: ingreso a nueva categoría',
  reclasificacion_resta: 'Reclasificación interna: salida de categoría anterior',
}

export function descripcionTipoMovimiento(tipo: string, descripcionApi?: string): string {
  if (tipo === TIPO_RECLASIFICACION_UI) {
    return 'Reclasificación de categoría'
  }
  return DESCRIPCION_TIPO_MOVIMIENTO[tipo] ?? descripcionApi ?? tipo
}

export function subtituloEfectoTipoMovimiento(efecto: string): string {
  if (efecto === 'suma') return 'Suma al inventario'
  if (efecto === 'resta') return 'Resta del inventario'
  if (efecto === 'reclasificacion') return 'Reclasificación de categoría'
  return 'Movimiento especial'
}

/** Tipos que no deben mostrarse como botones sueltos (van unificados en el flujo de reclasificación) */
export function ocultarEnSelectorTipoMovimiento(tipo: string): boolean {
  return tipo === TIPO_RECLASIFICACION_RESTA || tipo === TIPO_RECLASIFICACION_SUMA
}

export function esTipoMovimientoSoloSelectorUi(tipo: string): boolean {
  return tipo === TIPO_RECLASIFICACION_UI
}
